module.exports = __webpack_public_path__ + "static/media/chat.0829cf50.png";